import React from 'react';
import { bool, node, object, oneOf, oneOfType, string } from 'prop-types';

const mapAlignStyle = {
  top: { top: '2px' },
  middle: { top: 'initial' },
  bottom: { top: 'initial', bottom: '2px' },
};

const Checkbox = ({
  icon,
  children,
  className,
  checked,
  style,
  isStopPropagation,
  verticalAlign,
  ...rest
}) => {
  let displayClassName = 'ajaib-radio ajaib-radio-container';
  if (checked) {
    displayClassName += ' checked';
  }
  if (className) {
    displayClassName = `${displayClassName} ${className}`;
  }
  let classNameCheckMark = 'checkmark display-check checkbox';
  if (icon) {
    classNameCheckMark += ' with-icon';
  }
  const randId = Math.random().toString(36).substring(7);
  return (
    <label
      htmlFor={`checkbox-${randId}`}
      className={displayClassName}
      style={style}
      onClick={(e) => isStopPropagation && e.stopPropagation()}
    >
      <div className="d-flex align-items-center">
        <input
          id={`checkbox-${randId}`}
          type="checkbox"
          checked={checked}
          {...rest}
          style={{ visibility: 'hidden' }}
        />
        <span className={classNameCheckMark} style={mapAlignStyle[verticalAlign]} />
        <div className="ml-10">{children}</div>
      </div>
    </label>
  );
};

Checkbox.propTypes = {
  icon: bool,
  isStopPropagation: bool,
  className: string,
  style: object,
  children: oneOfType([node, string]),
  checked: bool,
  verticalAlign: oneOf(['top', 'middle', 'bottom']),
};

Checkbox.defaultProps = {
  icon: false,
  isStopPropagation: false,
  className: '',
  style: null,
  children: null,
  checked: false,
  verticalAlign: 'top',
};

export default Checkbox;
